import IllustrationWithInfo from './IllustrationWithInfo';

export default IllustrationWithInfo;
